export default __webpack_public_path__ + "static/media/foto_13.282945c0.jpg";